import React from 'react';
import { ConsoleScrollContainer, ErrorContainer, ErrorHeading, UL, LI } from './styles';

const ErrorList = ({ errors }) => (
  <UL>
    {errors?.mismatchedTags?.length > 0 && <LI>Mismatched tags: {errors.mismatchedTags.join(', ')}</LI>}
    {errors?.invalidTags?.length > 0 && <LI>Invalid tags: {errors.invalidTags.join(', ')}</LI>}
    {errors?.nestedTags?.length > 0 && <LI>Nested tags: {errors.nestedTags.join(', ')}</LI>}
    {errors?.defaultError?.length > 0 && <LI>Default error: {errors.defaultError.join(', ')}</LI>}
  </UL>
);

const TagError = ({ descriptionTagError, flowTagError }) => (
  <ConsoleScrollContainer>
    {descriptionTagError && (
      <ErrorContainer>
        <ErrorHeading>Tags with issues were found in description:</ErrorHeading>
        <ErrorList errors={descriptionTagError} />
      </ErrorContainer>
    )}
    {flowTagError && (
      <ErrorContainer>
        <ErrorHeading>Tags with issues were found in flow:</ErrorHeading>
        {Object.entries(flowTagError).map(([outerKey, innerErrors]) => (
          <ErrorContainer key={outerKey}>
            <ErrorContainer marginLeft="20">Level {outerKey}:</ErrorContainer>
            {Object.entries(innerErrors).map(([innerKey, error]) => (
              <ErrorContainer key={innerKey} marginLeft="40">
                <ErrorContainer>Nested level: {innerKey}</ErrorContainer>
                <ErrorList errors={error} />
              </ErrorContainer>
            ))}
          </ErrorContainer>
        ))}
      </ErrorContainer>
    )}
  </ConsoleScrollContainer>
);

export default TagError;
